module.exports = __webpack_public_path__ + "static/media/slider.3cab98c3.png";